import Cookies from 'js-cookie'
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_RECON_API_BASE_URL

const token = sessionStorage.getItem("biller_access");
  export default axios.create({
    baseURL: BASE_URL
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "69420",
     Authorization: `${token}`,
  },
});